<template>
  <footer class="w-100 footer">
    <b-container class="full-width">
      <div class="footer-content full-width">
        <b-row>
          <b-col>
            <!-- Sitemap -->
            <div class="wrapper footer-sitemap-wrapper">
              <b-container fluid="lg" class="full-width">
                <b-row>
                  <b-col class="d-flex justify-content-center">
                    <ul
                      class="
                        sitemap-wrapper
                        d-lg-flex d-md-flex d-sm-flex
                        justify-content-lg-center
                        justify-content-md-center
                        justify-content-sm-center
                      "
                    >
                      <li
                        v-for="(navlink, index) in navigationLinks"
                        :key="index"
                        class="sitemap-link"
                      >
                        <router-link :to="{ name: navlink.name }">
                          {{ navlink.meta.title }}
                        </router-link>
                      </li>
                    </ul>
                  </b-col>
                </b-row>
              </b-container>
            </div>

            <!-- Info: Address, telephone, cvr and email -->
            <div class="wrapper footer-info-wrapper">
              <b-container fluid="lg" class="full-width">
                <b-row align-v="center" class="">
                  <b-col
                    class="
                      d-md-flex d-sm-flex
                      justify-content-sm-center justify-content-md-center
                    "
                  >
                    <div
                      class="info-wrapper d-lg-flex justify-content-lg-center"
                    >
                      <p>absi ApS</p>
                      <b-icon-dot
                        class="d-none d-lg-block"
                        shift-v="-5"
                      ></b-icon-dot>

                      <p>Edvard Thomsens Vej 10, 6. sal</p>
                      <b-icon-dot
                        class="d-none d-lg-block"
                        shift-v="-5"
                      ></b-icon-dot>

                      <p>DK-2300 København S</p>
                      <b-icon-dot
                        class="d-none d-lg-block"
                        shift-v="-5"
                      ></b-icon-dot>

                      <p>Tlf.: <a class="info-link" href="tel:+4533267839">+45 3326 7839</a></p>
                      <b-icon-dot
                        class="d-none d-lg-block"
                        shift-v="-5"
                      ></b-icon-dot>

                      <p>CVR-nr.: 33880227</p>
                      <b-icon-dot
                        class="d-none d-lg-block"
                        shift-v="-5"
                      ></b-icon-dot>

                      <p>
                        E-mail: <a class="info-link" href="mailto:info@absi.dk">info@absi.dk</a>
                      </p>
                    </div>
                  </b-col>
                </b-row>
              </b-container>
            </div>

            <!-- Copyright -->
            <div class="wrapper footer-copyright-wrapper">
              <b-container fluid="lg" class="full-width">
                <b-row align-v="center">
                  <b-col class="d-flex justify-content-center">
                    <p>&copy; 2006 - {{ currentYear }} absi ApS</p>
                  </b-col>
                </b-row>
              </b-container>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  props: {
    navigationLinks: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      currentYear: new Date().getFullYear(),
      navLinks: this.$router.options.routes,
    };
  },
};
</script>

<style lang="scss" scoped>
.router-link-exact-active {
  text-decoration: underline;
}

// Mobile device
.container-lg {
  max-width: 100% !important;
}

.footer {
  background-color: $quinary;
  margin-top: auto;
  width: 100%;
  font-size: $content;

  .footer-content {
    max-width: $app-width;

    .wrapper {
      border-top: $border-footer;
      border-bottom: $border-footer;
      padding-top: 20px;
      padding-bottom: 10px;
      color: $secondary;
    }

    // Sitemap
    .sitemap-wrapper {
      list-style: none;
      column-gap: 50px;
      padding: 0;
      column-count: 2;

      .sitemap-link {
        margin-bottom: 15px;

        a {
          color: $secondary;
        }
      }
    }

    // Info
    .info-wrapper {
      text-align: center;

      p {
        margin-bottom: 8px;
      }

      .info-link {
        color: $primary;
      }
    }

  }
}

@media (min-width: 600px) {
  // Sitemap
  .sitemap-wrapper {
    justify-content: center !important;
    display: flex !important;
    column-gap: 0 !important;

    .sitemap-link {
      display: inline-block !important;
      margin: 0 30px !important;
      margin-bottom: 0 !important;
    }
  }

  // Info
  .info-wrapper {
    display: inline-block;
  }
}

@media (min-width: 1140px) {
  .container-lg {
    max-width: $app-width !important;
  }
}
</style>